import React from 'react';
import Email from './Email.js';
 
export default (props) => <Email {...props}/>;
